import styled, { css } from 'styled-components';
import { Row } from '@pickit/pickit-grid-system';

export const ChipContainer = styled(Row)`
  align-items: center;
  display: flex;
  font-family: 'Mulish', sans-serif;
  font-weight: 400;
  height: fit-content;
`;

export const Label = styled.label<{ isSelected: boolean; isSecondRowElement?: boolean }>`
  align-items: center;
  background: ${({ theme }) => theme.white};
  border: 1px solid ${({ theme }) => theme.gray4D};
  border-radius: 10px;
  box-sizing: border-box;
  color: ${({ theme }) => theme.gray4D};
  ${({ isSelected }) =>
    isSelected &&
    css`
      background-color: ${({ theme }) => theme.grayF0};
      box-shadow: 0px 5px 13px rgba(0, 0, 0, 0.29);
      font-weight: 700;
    `}
  ${({ isSecondRowElement }) =>
    isSecondRowElement &&
    css`
      margin-top: 36px;
    `}
  cursor: pointer;
  display: flex;
  font-size: 16px;
  height: 40px;
  justify-content: center;
  padding: 10px;
  user-select: none;
`;

export const Input = styled.input`
  display: none;
`;
